export const environment = {
  production: true,
  BACKEND_SERVER_URL: 'https://www.fotofil.no/api/v1'
};
